import angular from 'angular';
import BoxProductsMiniComponent from './box-products-mini.component';

let BoxProductsMiniModule = angular.module('catalog.productsModules.boxProductsMini', [])
  .component('boxProductsMini', BoxProductsMiniComponent);

export default BoxProductsMiniModule;



// WEBPACK FOOTER //
// ./www/components/catalog/box-products-mini/box-products-mini.js